import script from "./DesktopSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopSelect.vue?vue&type=script&setup=true&lang=js"

import "./DesktopSelect.vue?vue&type=style&index=0&id=39bda64d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39bda64d"]])

export default __exports__